export const workEnvironment = {
  junior: {
    macos: [
      { step: 'Install Chrome', command: 'brew install --cask google-chrome' },
      { step: 'Install Slack', command: 'brew install --cask slack' },
      { step: 'Install Figma', command: 'brew install --cask figma' },
      { step: 'Install Notion', command: 'brew install --cask notion' },
      { step: 'Install Grammarly', command: 'brew install --cask grammarly' },
      { step: 'Install VS Code', command: 'brew install --cask visual-studio-code' },
      { step: 'Install Hemingway Editor', command: 'Web-based writing tool - bookmark in browser' }
    ],
    windows: [
      { step: 'Install Chrome', command: 'choco install googlechrome' },
      { step: 'Install Slack', command: 'choco install slack' },
      { step: 'Install Figma', command: 'choco install figma' },
      { step: 'Install Microsoft Office', command: 'choco install office365business' },
      { step: 'Install Grammarly', command: 'choco install grammarly' },
      { step: 'Install VS Code', command: 'choco install vscode' },
      { step: 'Install Teams', command: 'choco install microsoft-teams' }
    ],
    linux: [
      { step: 'Install Chrome', command: 'wget -q -O - https://dl.google.com/linux/linux_signing_key.pub | sudo apt-key add - && echo "deb [arch=amd64] http://dl.google.com/linux/chrome/deb/ stable main" | sudo tee /etc/apt/sources.list.d/google-chrome.list && sudo apt update && sudo apt install google-chrome-stable' },
      { step: 'Install Slack', command: 'sudo snap install slack --classic' },
      { step: 'Install VS Code', command: 'sudo snap install code --classic' },
      { step: 'Install LibreOffice', command: 'sudo apt install libreoffice' },
      { step: 'Install Git', command: 'sudo apt install git' },
      { step: 'Install Typora', command: 'wget -qO - https://typora.io/linux/public-key.asc | sudo apt-key add - && sudo add-apt-repository "deb https://typora.io/linux ./" && sudo apt-get update && sudo apt-get install typora' }
    ]
  },
  mid: {
    macos: [
      { step: 'Install Airtable', command: 'brew install --cask airtable' },
      { step: 'Install Miro', command: 'brew install --cask miro' },
      { step: 'Install Sketch', command: 'brew install --cask sketch' },
      { step: 'Install ContentKing', command: 'Web-based content optimization platform' },
      { step: 'Install Loom', command: 'brew install --cask loom' },
      { step: 'Install Zeplin', command: 'brew install --cask zeplin' }
    ],
    windows: [
      { step: 'Install Power BI Desktop', command: 'choco install powerbi' },
      { step: 'Install SharePoint Designer', command: 'Download from Microsoft' },
      { step: 'Install Advanced Excel', command: 'Configure advanced Excel features for content analysis' },
      { step: 'Install Power Automate', command: 'Web-based workflow automation platform' },
      { step: 'Install Visio', command: 'choco install visio' }
    ],
    linux: [
      { step: 'Install Hugo', command: 'sudo snap install hugo' },
      { step: 'Install Jekyll', command: 'sudo apt install ruby-full build-essential zlib1g-dev && gem install jekyll bundler' },
      { step: 'Install Pandoc', command: 'sudo apt install pandoc' },
      { step: 'Install Node.js', command: 'curl -fsSL https://deb.nodesource.com/setup_lts.x | sudo -E bash - && sudo apt-get install -y nodejs' },
      { step: 'Install Gatsby CLI', command: 'npm install -g gatsby-cli' }
    ]
  },
  senior: {
    macos: [
      { step: 'Install Content Strategy Suite', command: 'Configure enterprise content management tools' },
      { step: 'Install Advanced Analytics Tools', command: 'Set up content performance and analytics platforms' },
      { step: 'Install Content Automation Tools', command: 'Configure AI-assisted content creation tools' },
      { step: 'Install Enterprise CMS Tools', command: 'Set up headless CMS and content infrastructure' }
    ],
    windows: [
      { step: 'Install Advanced SharePoint', command: 'Configure SharePoint Premium features for content management' },
      { step: 'Install Power Platform Premium', command: 'Set up advanced Power Platform for content automation' },
      { step: 'Install Azure Cognitive Services', command: 'Configure AI content analysis and generation tools' },
      { step: 'Install Advanced Analytics Suite', command: 'Set up enterprise content analytics and reporting' }
    ],
    linux: [
      { step: 'Install Content Infrastructure Stack', command: 'docker-compose up -d for headless CMS, API gateway, and content services' },
      { step: 'Install AI Content Tools', command: 'pip3 install transformers torch openai anthropic' },
      { step: 'Install Content Automation Pipeline', command: 'pip3 install airflow celery redis' },
      { step: 'Install Advanced Analytics', command: 'pip3 install pandas numpy matplotlib seaborn plotly dash streamlit' }
    ]
  }
};
